import React from 'react';
import { LegalLayout } from '../components/legal/LegalLayout';
import { useLanguage } from '../contexts/LanguageContext';
export function Disclaimer() {
  const {
    t
  } = useLanguage();
  const sections = t('legal.disclaimer.sections') || [];
  return <LegalLayout title={t('legal.disclaimer.title')} lastUpdated="October 24, 2024" data-id="element-201">
      <p data-id="element-202">{t('legal.disclaimer.intro')}</p>

      {sections.map((section: any, index: number) => <div key={index} data-id="element-203">
          <h2 data-id="element-204">{section.heading}</h2>
          {section.paragraphs.map((p: string, pIndex: number) => <p key={pIndex} data-id="element-205">{p}</p>)}
          {section.list && <ul data-id="element-206">
              {section.list.map((item: string, lIndex: number) => <li key={lIndex} data-id="element-207">{item}</li>)}
            </ul>}
        </div>)}
    </LegalLayout>;
}